export const formatRelativeTime = (iso: string): string => {
  const value = new Date(iso).valueOf();
  const deltaMinutes = Math.max(0, Math.floor((Date.now() - value) / 60000));
  if (deltaMinutes < 60) return `${deltaMinutes || 1} min fa`;
  const hours = Math.floor(deltaMinutes / 60);
  if (hours < 24) return `${hours}h fa`;
  const days = Math.floor(hours / 24);
  return `${days}g fa`;
};

export const formatDate = (iso: string): string => new Intl.DateTimeFormat('it-IT', {
  day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
}).format(new Date(iso));
